import React, { useState, useEffect,useRef } from "react";
import { __ } from '@wordpress/i18n';
import { createRoot } from "react-dom/client";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, toast } from "react-toastify";

// CSS
import "./css/wizard-menu.css";

// Pages
import Business from "./pages/Business";
import Store from "./pages/Store";
import Account from "./pages/Account";
import Payment from "./pages/Payment";
import Success from "./pages/Success";

const logo = `${EASYCOMMERCE.assets}common/img/logo.png`;
const check = `${EASYCOMMERCE.assets}admin/img/icons/check.png`;

const tabs = ["/business", "/store","/payment", "/account", "/success"];
const defaultTab = tabs[0];

const App = () => {
    const formRef = useRef();
    const [activeTab, setActiveTab] = useState(
        window.location.hash.replace("#", "") || defaultTab
    );
    const [isAPIKeyVisible, setIsAPIKeyVisible] = useState(false);

    const showToast = (type, message) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    const [formValues, setFormValues] = useState({
        store_name: "",
        logo: "",
        business_type: "",
        country: "",
        email: "",
        shop: "",
        checkout: "",
        dashboard: "",
        currency: "",
        format : "",
        payment_methods: [],
        name: "",
        apiKey: "",
        dont_share_data: false
    });

    useEffect(() => {
        fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/get`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data?.data?.data) {
                    const d = data.data.data;
                    console.log(d);
                    setFormValues({
                        store_name: d.store_name || "",
                        logo: d.logo || "",
                        business_type: d.business_type || "",
                        country: d.country || "",
                        email: d.business_email || "",
                        shop: d.shop || "",
                        checkout: d.checkout || "",
                        dashboard: d.dashboard || "",
                        currency: d.currency || "",
                        format : d.format || "",
                        payment_methods: d.payment_methods || [],
                        name: d.name || EASYCOMMERCE.user.data.display_name,
                    });
                }
            });
    }, []);

    useEffect(() => {
        const handleHashChange = () => {
            const newHash = window.location.hash.replace("#", "");
            if (tabs.includes(newHash)) {
                setActiveTab(newHash);
            } else {
                setActiveTab(defaultTab);
                window.location.hash = defaultTab;
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    const saveDataToAPI = () => {
        const formDataObject = new FormData(formRef.current);
        const entries        = Object.fromEntries(formDataObject.entries());
        const paymentMethods = formDataObject.getAll('payment-methods-active_methods');

        entries['payment-methods-active_methods'] = paymentMethods;
    
        console.log(entries);

        fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/save`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
            body: JSON.stringify({
                type: activeTab.replace("/", ""),
                data: entries
                }),
            })
            .then((res) => res.json())
            .then((result) => {
            console.log("Saved:", result);
            });
    };
    const handleNext = () => {
        const currentIndex = tabs.indexOf(activeTab);

        if (activeTab === "/account") {
            if (!isAPIKeyVisible) {
                easycommerce_modal(true);
                fetch(`${EASYCOMMERCE.rest_base}/connectivity/token`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": EASYCOMMERCE.nonce,
                    },
                    body: JSON.stringify({
                        name: formValues.name,
                        email: formValues.email,
                        source: EASYCOMMERCE.home_url
                    }),
                })
                .then(response => response.json())
                    .then(data => {
                        setTimeout(() => {
                            easycommerce_modal(false);
                            if (data.success) {
                                setIsAPIKeyVisible(true);
                                showToast("success","API Key Sent to your email");
                            } else {
                                showToast("error", "Failed to send API key");
                            }
                        }, 1000);
                    })
                    .catch(() => {
                        showToast("error", "Something went wrong");
                });
                
            } else {
                if (currentIndex < tabs.length - 1) {
                    if (
                        activeTab === "/account" &&
                        formValues.email &&
                        formValues.apiKey
                    ) {
                        easycommerce_modal(true);
                        fetch(`${EASYCOMMERCE.rest_base}/connectivity/token/verify`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-WP-Nonce": EASYCOMMERCE.nonce,
                            },
                            body: JSON.stringify({
                                email: formValues.email,
                                token: formValues.apiKey,
                            }),
                        })
                        .then(response => response.json())
                            .then(data => {
                                easycommerce_modal(false);
                                if (data.success && data.data?.verified) {
                                    showToast("success", "API Key Verified Successfully");
                                    const nextTab = tabs[currentIndex + 1];
                                    setActiveTab(nextTab);
                                    window.location.hash = nextTab;
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                } else {
                                    showToast("error", "API Key verification failed");
                                }
                            })
                            .catch(() => {
                                easycommerce_modal(false);
                                showToast("error", "Something went wrong");
                        });
                    }
                }
            }
        } else {
            if (currentIndex < tabs.length - 1) {
                const nextTab = tabs[currentIndex + 1];
                setActiveTab(nextTab);
                window.location.hash = nextTab;
                window.scrollTo({ top: 0, behavior: "smooth" });

                saveDataToAPI(); 
            }
        }
    };

    
    const handlePrevious = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > 0) {
            const prevTab = tabs[currentIndex - 1];
            setActiveTab(prevTab);
            window.location.hash = prevTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleSkip = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex < tabs.length - 1) {
            const nextTab = tabs[currentIndex + 1];
            setActiveTab(nextTab);
            window.location.hash = nextTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const getStepClassName = (index) => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > index) {
            return "bg-ec-primary text-white";
        } else if (currentIndex === index) {
            return "bg-ec-primary text-white";
        } else {
            return "border-2 border-[#E0E8FF] text-ec-secondary bg-[#EEF2FF]";
        }
    };

    const completedTabIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
            <circle cx="13.5" cy="13" r="13" fill="#19AA79"/>
            <path d="M19.2589 9.225C19.4196 9.39167 19.5 9.58333 19.5 9.8C19.5 10.0167 19.4196 10.2083 19.2589 10.375L12.4018 16.775C12.2232 16.925 12.0179 17 11.7857 17C11.5536 17 11.3482 16.925 11.1696 16.775L7.74107 13.575C7.58036 13.4083 7.5 13.2167 7.5 13C7.5 12.7833 7.58036 12.5917 7.74107 12.425C7.91964 12.275 8.125 12.2 8.35714 12.2C8.58929 12.2 8.79464 12.275 8.97321 12.425L11.7589 15.075L18.0268 9.225C18.2054 9.075 18.4107 9 18.6429 9C18.875 9 19.0804 9.075 19.2589 9.225Z" fill="white"/>
        </svg>
    )

    const activeTabIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
            <circle cx="13.5" cy="13" r="12" stroke="#7351FD" stroke-width="2"/>
            <path d="M19.2589 9.225C19.4196 9.39167 19.5 9.58333 19.5 9.8C19.5 10.0167 19.4196 10.2083 19.2589 10.375L12.4018 16.775C12.2232 16.925 12.0179 17 11.7857 17C11.5536 17 11.3482 16.925 11.1696 16.775L7.74107 13.575C7.58036 13.4083 7.5 13.2167 7.5 13C7.5 12.7833 7.58036 12.5917 7.74107 12.425C7.91964 12.275 8.125 12.2 8.35714 12.2C8.58929 12.2 8.79464 12.275 8.97321 12.425L11.7589 15.075L18.0268 9.225C18.2054 9.075 18.4107 9 18.6429 9C18.875 9 19.0804 9.075 19.2589 9.225Z" fill="#7351FD"/>
        </svg>
    )

    const inactiveTabIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
            <circle cx="13.5" cy="13" r="12" stroke="#7F7F98" stroke-width="2"/>
            <path d="M19.2589 9.225C19.4196 9.39167 19.5 9.58333 19.5 9.8C19.5 10.0167 19.4196 10.2083 19.2589 10.375L12.4018 16.775C12.2232 16.925 12.0179 17 11.7857 17C11.5536 17 11.3482 16.925 11.1696 16.775L7.74107 13.575C7.58036 13.4083 7.5 13.2167 7.5 13C7.5 12.7833 7.58036 12.5917 7.74107 12.425C7.91964 12.275 8.125 12.2 8.35714 12.2C8.58929 12.2 8.79464 12.275 8.97321 12.425L11.7589 15.075L18.0268 9.225C18.2054 9.075 18.4107 9 18.6429 9C18.875 9 19.0804 9.075 19.2589 9.225Z" fill="#7F7F98"/>
        </svg>
    )

    return (
        <div
            className={`${
                activeTab === "/account" && "h-screen"
            } flex justify-center items-center`}
        >
            <div className="w-full h-screen flex flex-col items-center bg-ec-main-bg">
                {activeTab !== "/success" && (
                    <div className="w-full bg-white">
                        <div className="container flex items-center justify-between p-6 mx-auto">
                            <img
                                src={logo}
                                alt="easycommerce"
                                className="w-[158px]"
                            />

                            <div className="relative flex flex-col items-center w-[725px]">
                                <div className="relative w-full">
                                    <div className="flex justify-between">
                                        {tabs.map((tab, index) => (
                                            <div
                                                key={index}
                                                className="relative z-10 flex gap-3 items-center"
                                            >
                                                {activeTab === tab ? (
                                                    tabs.indexOf(activeTab) > index ? completedTabIcon : activeTabIcon
                                                ) : (tabs.indexOf(activeTab) > index ? completedTabIcon : inactiveTabIcon)}
                                                <div
                                                    className={`text-center text-[16px] capitalize ${
                                                        activeTab === tab
                                                            ? "text-ec-primary"
                                                            : "text-ec-body"
                                                    }`}
                                                >
                                                    {tab.replace("/", "")}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <button
                                className="font-inter underline font-normal text-base leading-[26px]
                                hover:text-ec-secondary text-ec-body transition-all ease-in-out duration-300"
                                onClick={handleSkip}
                            >
                                {__("Skip", "easycommerce")}
                            </button>
                        </div>
                    </div>
                )}

                {["/business", "/store", "/payment", "/account"].includes(activeTab) && (
                    <div className="pt-8 w-full bg-ec-main-bg">
                        <form ref={formRef} className="mb-12 w-[870px] px-[70px] pt-[45px] pb-[60px] mx-auto bg-white rounded-[20px]">
                            <div>
                                <div className={activeTab === "/business" ? "block" : "hidden"}>
                                    <Business formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/store" ? "block" : "hidden"}>
                                    <Store formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/payment" ? "block" : "hidden"}>
                                    <Payment formValues={formValues} setFormValues={setFormValues} />
                                </div>
                                <div className={activeTab === "/account" ? "block" : "hidden"}>
                                    <Account isAPIKeyVisible={isAPIKeyVisible} formValues={formValues} setFormValues={setFormValues} />
                                </div>
                            </div>

                            <div className="mt-8 flex justify-between items-center gap-4">
                                <div>
                                    {activeTab !== defaultTab &&
                                        activeTab !== tabs[tabs.length - 1] && (
                                            <button
                                                type="button"
                                                onClick={handlePrevious}
                                                className="w-[120px] h-12 bg-transparent font-inter font-normal 
                                                text-ec-primary hover:text-white text-base leading-[26px] border 
                                                border-ec-primary rounded-lg focus:shadow-none hover:bg-ec-primary 
                                                transition-all ease-in-out duration-300"
                                            >
                                                {__("Previous", "easycommerce")}
                                            </button>
                                        )}
                                </div>

                                <div className="flex justify-end items-center gap-8">
                                    {activeTab !== tabs[tabs.length - 1] && (
                                        <button
                                            onClick={handleNext}
                                            type="button"
                                            className="w-[120px] h-12 font-inter bg-ec-primary group border border-ec-primary 
                                            rounded-lg text-white font-normal hover:text-white hover:bg-ec-secondary 
                                            focus:shadow-none lg:text-base md:text-xs sm:text-sm transition-all ease-in-out 
                                            duration-300 leading-[26px]"
                                        >
                                            {__("Next", "easycommerce")}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                )}

                {activeTab === "/success" && (
                    <div className="w-full h-screen bg-ec-main-bg">
                        <Success/>
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};
const container = document.getElementById("easycommerce_wizard_render");
const root = createRoot(container);
root.render(
    <App />
);
